import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Label, Box, Emoji } from 'hosman-material';
import { exclamationMark } from '../../../../../../../../../shared/assets/emojis';

const Action = ({ icon, title, displayed, emoji, important = false, children, classes }) => {
  return (
    <>
      {displayed &&
        <div className={`flex flex-col md:flex-row text-center md:text-left items-center justify-between gap-4 ${classes}`}>
          <div className='flex flex-col md:flex-row text-center md:text-left items-center gap-2'>
            <Box>
              <FontAwesomeIcon icon={icon} size='lg' className='text-ih-blue' />
            </Box>
            <p className='h4 text-ih-indigo'>{title}</p>
            {emoji && <Emoji emojiSrc={emoji} width='w-5' />}
            {important && 
              <div>
                <Label color='bg-ih-indigo'>
                  <div className='flex items-center gap-1'>
                    <p>Important</p>  
                    <Emoji emojiSrc={exclamationMark} width='w-5' />
                  </div>
                </Label>
              </div>
            }
          </div>
          {children}
        </div>
      }
    </>
  )
}

export default Action;

Action.propTypes = {
  icon: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  displayed: PropTypes.bool,
  important: PropTypes.bool,
  children: PropTypes.node
};
